import { CardBody, CardBodyProps } from "reactstrap"

export type TooltipContentProps = CardBodyProps

export const TooltipContent = CardBody
